import _ from 'lodash';

export const getCommaSeparatedApprovers = (approvers) => {
  if (!approvers) {
    return null;
  }
  return approvers.join(", ");
};